import { getContract as getContractWagmi } from '@wagmi/core'
import config from 'app/configWagmi'
import constants from 'app/constants'
import { getBlockchainErrorStatus } from 'app/util/errorCodes'
import loadAbi from './loadAbi'

/**
 * Edit an avatar with the users wallet
 *
 * @param {object} submissionData - the compiled checkout data
 * @param {object} walletClient - the wallet client
 * @returns {Promise} resolves on completion
 */
const mintEditAvatarWithWallet = async (submissionData, walletClient) => {
  const { accessoryIdsToAttach, accessoryIdsToDetach, id } = submissionData
  const contractInfo = constants.CONTRACTS.AvatarCollection
  const { publicClient } = config
  const abiData = await loadAbi(contractInfo.abiUrl)
  const contract = await getContractWagmi({
    address: contractInfo.address,
    abi: abiData.abi,
    walletClient
  })

  let hash
  let transactionInfo

  try {
    hash = await contract.write.editAvatar({
      args: [id, accessoryIdsToDetach, accessoryIdsToAttach]
    })

    transactionInfo = await publicClient.waitForTransactionReceipt({ hash })
  } catch (err) {
    console.error(err)

    return getBlockchainErrorStatus(err)
  }

  const success = transactionInfo?.status === 'success'

  return {
    success,
    data: transactionInfo,
    message: !success && 'Transaction failed.'
  }
}

// Export
export default mintEditAvatarWithWallet
